export const columns: TableColumn[] = [
    {
        Header: "tableCommon.sl_no",
        accessor: "slno",
    },
    {
        Header: "downloadPdfScreen.reportName",
        accessor: "document_name",
    },
    {
        Header: "Generated By",
        accessor: "generated_user_name",
    },
    {
        Header: "downloadPdfScreen.generated_datetime",
        accessor: "generated_date_time",
    },
    {
        Header: "QA Status",
        accessor: "file_status",
    },
    
    
  ];


    
  interface TableColumn {
    Header: string;
    accessor: string;
  }